import { OrderBaseUrls } from '@ravago/shared/page-data/models/elements';

export async function getOrderBaseUrls(language: string): Promise<OrderBaseUrls> {
  const response = await fetch(`/api/orders/routes?language=${language}`);
  if (!response.ok) {
    return {
      orderOverviewBaseUrl: '',
      orderDetailBaseUrl: '',
      shipmentBaseUrl: '',
      callOffAgreementBaseUrl: '',
      productBaseUrl: ''
    };
  }
  return response.json();
}
